import { render, staticRenderFns } from "./goodsRank.vue?vue&type=template&id=6837404e&scoped=true&"
import script from "./goodsRank.vue?vue&type=script&lang=js&"
export * from "./goodsRank.vue?vue&type=script&lang=js&"
import style0 from "./goodsRank.vue?vue&type=style&index=0&id=6837404e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837404e",
  null
  
)

export default component.exports